const BASE_URL: string = process.env.REACT_APP_BASE_URL as string;

// Add or replace routes
export const API_ROUTES: { [key: string]: string } = {
	// Bartender
	bartenders: `${BASE_URL}bartenders`,
	customerBartenders: `${BASE_URL}custom-bartender`,
	getSingleBartender: `${BASE_URL}bartenders`,
	businessAdmin: `${BASE_URL}bartenders/businessadmin`,
	bartenderAvatar: `${BASE_URL}bartenders/avatar`,
	bartenderSchedule: `${BASE_URL}bartenders/scheduler`,
	toggleUserActive: `${BASE_URL}users/active`,
	packages: `${BASE_URL}packages`,
	singlePackageApi: `${BASE_URL}packages/packageid`,
	// Moved to Business section (MyBusiness.tsx) — now backed by business.custom_quote_description
	// updateCustomQuoteDescription: `${BASE_URL}packages/packageid/:id/custom-quote-description`,
	packageGarnishes: `${BASE_URL}garnish`,
	bartenderOneDaySchedule: `${BASE_URL}bartenders/adhoc`,
	getBartenderOneDaySchedule: `${BASE_URL}bartenders/adhoc`,
	deleteBartenderOneDaySchedule: `${BASE_URL}bartenders/adhoc`,
	bartenderBlockedDate: `${BASE_URL}bartenders/blocks`,
	allBartenders: `${BASE_URL}bartenders/list`,
	discounts: `${BASE_URL}discounts`,
	signin: `${BASE_URL}users/login`,
	signup: `${BASE_URL}users/register`,
	changePassword: `${BASE_URL}users/changepassword`,
	forgotPassword: `${BASE_URL}users/forgetPassword`,
	resetPasswordRoute: `${BASE_URL}users/reset-password`,
	newpasswordRoute: `${BASE_URL}resetPassword`,
	checkForgetToken: `${BASE_URL}users/expiry`,
	addCompanyApi: `${BASE_URL}business`,
	getCompanyApi: `${BASE_URL}business/getbusiness`,
	getActiveCompanyApi: `${BASE_URL}business/getactivebusinesslist`,
	editCompanyApi: `${BASE_URL}business`,
	addPackageApi: `${BASE_URL}packages`,
	packageToggle: `${BASE_URL}packages/togglestatus`,
	getAllBusinesses: `${BASE_URL}business/getbusinesslist`,
	toggleBusinessStatus: `${BASE_URL}business/togglestatus`,
	toggleBusinessOptionStatus: `${BASE_URL}business/application-access`,
	uploadImageApi: `${BASE_URL}uploads`,
	products: `${BASE_URL}products`,
	productMixers: `${BASE_URL}products/mixers`,
	businessProducts: `${BASE_URL}products/business`,
	productsPreferences: `${BASE_URL}products/preferences`,
	cocktail: `${BASE_URL}cocktails/businesscocktails`,
	rawCcktailList: `${BASE_URL}cocktails/businesscocktailslist`,
	cocktailWIthoutGroupBy: `${BASE_URL}cocktails/withoutgroupby`,
	createCocktail: `${BASE_URL}cocktails/createcocktail`,
	toggleCocktailApi: `${BASE_URL}cocktails/togglestatus`,
	getSingleCocktail: `${BASE_URL}cocktails/cocktailid`,
	getAllCocktaillist: `${BASE_URL}cocktails/allcocktails`,
	// Events
	getPastEventApi: `${BASE_URL}booking/list/past`,
	getUpcomingEventApi: `${BASE_URL}booking/list/upcoming`,
	getUpcomingEventDashboardApi: `${BASE_URL}booking/list/upcoming/starttime`,
	getEventsCountApi: `${BASE_URL}booking/list/count`,
	getEventDetailApi: `${BASE_URL}booking/getbooking`,
	getAvailableBartendersApi: `${BASE_URL}booking/availablebartender`,
	updateBookingBartendersApi: `${BASE_URL}booking/changebookingbartender`,
	addEventNoteApi: `${BASE_URL}booking/addnote`,
	getEventNotesApi: `${BASE_URL}booking/getnote`,
	deleteEventNodeApi: `${BASE_URL}booking/deletenote`,
	updateEventNoteApi: `${BASE_URL}booking/updatenote`,
	// Package
	packageDefaultSupplies: `${BASE_URL}packages/defaultsupply`,
	// notification
	notificaitonListApi: `${BASE_URL}notifications`,
	notificaitonCountApi: `${BASE_URL}notifications/notificationcount`,
	markAsReadNotificationApi: `${BASE_URL}notifications`,
	// upload video
	bsnsUploadVid: `${BASE_URL}business/video`,
	bsnsDeleteVid: `${BASE_URL}business/video`,
	// upload image
	bsnsUploadImg: `${BASE_URL}business/image`,
	bsnsDeleteImg: `${BASE_URL}business/image`,
	// Upload File
	uploadFileApi: `${BASE_URL}upload/file`,
	deleteFileApi: `${BASE_URL}upload/file`,
	//Dashboard
	//Revenue Api
	getRevenueApi: `${BASE_URL}revenue`,
	getRevnuePackage: `${BASE_URL}revenue/packages`,
	//Chart
	getChartRevenue: `${BASE_URL}revenue/chart`,
	// payments
	getPaymentsApi: `${BASE_URL}payments`,
	postPaymentApi: `${BASE_URL}payments`,
	postPaymentChargeApi: `${BASE_URL}payments/alcohol-payment-charge`,
	postPaymentBtcChargeApi: `${BASE_URL}payments/btc-payments`,
	postPaymentPreviewApi: `${BASE_URL}payments/preview-payment-invoice`,
	getBookingTransactionApi: `${BASE_URL}payments`,
	downloadPdfInvoice: `${BASE_URL}payments/invoicedetails`,
	downloadStorePdfInvoice: `${BASE_URL}payments/store-invoice`,
	updateCustomerCard: `${BASE_URL}payments/update-customer-card`,
	updateStripeCard: `${BASE_URL}payments/card-update-token`,
	// Stripe and subscription
	setUpIntent: `${BASE_URL}billing/create-setup-intent`,
	savePaymentMethod: `${BASE_URL}billing/addcard`,
	// getCardInfoApi:`${BASE_URL}billing/card`,
	getProductDetailApi: `${BASE_URL}billing/product`,
	billingHistoryApi: `${BASE_URL}billing/history`,
	billingDetailsApi: `${BASE_URL}billing/billingdetail`,
	cancelSubscriptionApi: `${BASE_URL}billing/cancel-subscription`,
	subscriptApi: `${BASE_URL}billing/restart-subscription`,
	pendingInvoicesApi: `${BASE_URL}billing/pending-invoices`,
	//stores
	getStoresApi: `${BASE_URL}stores`,
	//cocktails
	cocktailByFilter: `${BASE_URL}cocktails/get-by-filters`,
	//quote
	getStoreByBusinessId: `${BASE_URL}stores/by-business`,
	getAllTypes: `${BASE_URL}quotes/product-types`,
	getCocktailsByType: `${BASE_URL}cocktails/get-by-filters`,
	getProductBrand: `${BASE_URL}products/get-products`,
	createQuote: `${BASE_URL}quotes`,
	listAllQuotesWithFilteration: `${BASE_URL}quotes`,
	getQuoteCountByStatus: `${BASE_URL}quotes/count-by-status`,
	getPaginatedQuotesList: `${BASE_URL}quotes/list`,
	deleteQuoteById: `${BASE_URL}quotes`,
	quoteStage: `${BASE_URL}quotes/stage`,
	//checkout
	createCheckout: `${BASE_URL}checkout`,
	createQuoteCheckout: `${BASE_URL}quote-checkout`,
	//contracts
	getAllContracts: `${BASE_URL}contracts/list`,
	contract: `${BASE_URL}contracts`,
	//reward points
	getRewardPointsGlobalApi: `${BASE_URL}rewards/global`,
	getRewardPointsBalanceApi: `${BASE_URL}rewards/balance`,
	getRewardPointsEarnedApi: `${BASE_URL}rewards/earned`,
	getRewardPointsBreakdownApi: `${BASE_URL}rewards/breakdown`,
	getRewardPointsLogsApi: `${BASE_URL}rewards/logs`,
	adjustBulkRewardPointsApi: `${BASE_URL}rewards/adjust-bulk`,
	//cashflow
	createBulkCashflowApi: `${BASE_URL}cashflow/create-bulk`,
	getStripeBalanceApi: `${BASE_URL}cashflow/stripe-balance`,
	getCashflowLogsApi: `${BASE_URL}cashflow/logs`,
	//resources
	addResourceApi: `${BASE_URL}resources`,
	uploadResourceFileApi: `${BASE_URL}resources/upload`,
	listResourcesApi: `${BASE_URL}resources/list`,
	//campaigns
	campaignsApi: `${BASE_URL}campaigns`,
	listCampaignsApi: `${BASE_URL}campaigns/list`,
	uploadCampaignImageApi: `${BASE_URL}campaigns/upload`,
	activeCampaignApi: `${BASE_URL}campaigns/active`,
};
